/**
 * tagEnums
 *
 * Enum-like maps and ordered lists for tags used by templates, videos,
 * and stock categories.
 */
export const TAGS = {
  REPUBLICAN: 'Republican',
  DEMOCRAT: 'Democrat',
  NONPARTISAN: 'Nonpartisan',
  VOTER_PERSUASION: 'Voter Persuasion',
  FUNDRAISING: 'Fundraising',
  NON_PROFIT: 'Non Profit',
  GOTV: 'GOTV',
  SURVEY: 'Survey',
  ISSUE_ADVOCACY: 'Issue Advocacy',
  STATE: 'State',
  CONGRESS: 'Congress',
  SENATE: 'Senate',
  PRESIDENTIAL: 'Presidential',
  GOVERNMENT_OFFICE: 'Government Office',
  HOLIDAY: 'Holiday',
  SOCIAL_MEDIA_GRAPHIC: 'Social Media Graphic',
  QUOTE: 'Quote',
  PERSUASION: 'Persuasion',
  POLLING: 'Polling',
  LOCAL: 'Local',
  EVENT: 'Event',
  MEME: 'Meme',
  ENDORSEMENT: 'Endorsement'
};

// Video-specific tags
export const VIDEO_TAGS = {
  VERTICAL: 'Vertical',
  LANDSCAPE: 'Landscape',
  SUPPORTER_VIDEOS: 'Supporter Videos',
};

// Video Template format tags for social media platforms
export const VIDEO_TEMPLATE_FORMAT_TAGS = {
  SQUARE: 'Square Format',
  FULLSCREEN: 'Full Screen Format'
};

// Mail Template tags (using top 6 most popular template tags)
export const MAIL_TEMPLATE_TAGS = {
  REPUBLICAN: 'Republican',
  DEMOCRAT: 'Democrat',
  SENATE: 'Senate',
  FUNDRAISING: 'Fundraising',
  CONGRESS: 'Congress',
  PERSUASION: 'Persuasion'
};

// Website Template tags
export const WEBSITE_TAGS = {
  LOCAL: 'Local',
  STATE: 'State'
};

// Stock video categories for political ad companies
export const STOCK_VIDEO_CATEGORIES = {
  PEOPLE: 'People',
  BUSINESS: 'Business',
  GOVERNMENT: 'Government',
  COMMUNITY: 'Community',
  FAMILY: 'Family',
  ECONOMY: 'Economy',
  HEALTHCARE: 'Healthcare',
  EDUCATION: 'Education',
  INFRASTRUCTURE: 'Infrastructure',
  NATURE: 'Nature',
  TECHNOLOGY: 'Technology',
  SCHOOL: 'School'
};

// Array representation of tags in the specified order (based on usage statistics)
export const TAG_LIST = [
  TAGS.REPUBLICAN,
  TAGS.DEMOCRAT,
  TAGS.SENATE,
  TAGS.FUNDRAISING,
  TAGS.CONGRESS,
  TAGS.PERSUASION,
  TAGS.SURVEY,
  TAGS.GOVERNMENT_OFFICE,
  TAGS.ISSUE_ADVOCACY,
  TAGS.PRESIDENTIAL,
  TAGS.NONPARTISAN,
  TAGS.GOTV,
  TAGS.STATE,
  TAGS.EVENT,
  TAGS.ENDORSEMENT,
  TAGS.SOCIAL_MEDIA_GRAPHIC,
  TAGS.QUOTE,
  TAGS.HOLIDAY,
  TAGS.POLLING,
  TAGS.MEME,
  TAGS.VOTER_PERSUASION,
  TAGS.LOCAL,
  TAGS.NON_PROFIT
];

// Video tags list
export const VIDEO_TAG_LIST = [
  VIDEO_TAGS.VERTICAL,
  VIDEO_TAGS.LANDSCAPE,
  VIDEO_TAGS.SUPPORTER_VIDEOS
];

// Video template format tags list (for social media formats)
export const VIDEO_TEMPLATE_FORMAT_LIST = [
  VIDEO_TEMPLATE_FORMAT_TAGS.SQUARE,
  VIDEO_TEMPLATE_FORMAT_TAGS.FULLSCREEN
];

// Stock video categories list (12 broad categories for political ad use)
export const STOCK_VIDEO_CATEGORY_LIST = [
  STOCK_VIDEO_CATEGORIES.PEOPLE,
  STOCK_VIDEO_CATEGORIES.BUSINESS,
  STOCK_VIDEO_CATEGORIES.GOVERNMENT,
  STOCK_VIDEO_CATEGORIES.COMMUNITY,
  STOCK_VIDEO_CATEGORIES.FAMILY,
  STOCK_VIDEO_CATEGORIES.ECONOMY,
  STOCK_VIDEO_CATEGORIES.HEALTHCARE,
  STOCK_VIDEO_CATEGORIES.EDUCATION,
  STOCK_VIDEO_CATEGORIES.INFRASTRUCTURE,
  STOCK_VIDEO_CATEGORIES.NATURE,
  STOCK_VIDEO_CATEGORIES.TECHNOLOGY,
  STOCK_VIDEO_CATEGORIES.SCHOOL
];

// Mail template tags list
export const MAIL_TEMPLATE_TAG_LIST = [
  MAIL_TEMPLATE_TAGS.REPUBLICAN,
  MAIL_TEMPLATE_TAGS.DEMOCRAT,
  MAIL_TEMPLATE_TAGS.SENATE,
  MAIL_TEMPLATE_TAGS.FUNDRAISING,
  MAIL_TEMPLATE_TAGS.CONGRESS,
  MAIL_TEMPLATE_TAGS.PERSUASION
];

// Website template tags list
export const WEBSITE_TAG_LIST = [
  WEBSITE_TAGS.LOCAL,
  WEBSITE_TAGS.STATE
];

// Default number of visible tags before "More" dropdown
export const VISIBLE_TAGS_COUNT = 6; 